module.exports = __webpack_public_path__ + "img/沙苑子.9aba23c0.jpg";